import type { Hexcode } from 'hephaestus/core';

/**
 * Pre-hephaestus chart palette. OVT-7688 remapped support tokens on the
 * theme; charts keep these hexes so series colors stay unchanged.
 */
export type ChartSupportColorKey =
  | 'supportOne'
  | 'supportTwo'
  | 'supportThree'
  | 'supportFour'
  | 'supportFive'
  | 'supportSix';

export const CHART_COLOR_BY_SUPPORT: Record<ChartSupportColorKey, Hexcode> = {
  supportOne: '#297AA3',
  supportTwo: '#70BBC2',
  supportThree: '#F0BD42',
  supportFour: '#E27F36',
  supportFive: '#D65C85',
  supportSix: '#B670C2',
};

/** Old support*40 light ramps, used for template overlay slices. */
export const CHART_COLOR_VARIANT_BY_SUPPORT: Record<
  ChartSupportColorKey,
  Hexcode
> = {
  supportOne: '#C2DDF0',
  supportTwo: '#D5EFF1',
  supportThree: '#F8E9A5',
  supportFour: '#FAD3B8',
  supportFive: '#F6C0D2',
  supportSix: '#E5B9F9',
};

export const getChartColors = (): Hexcode[] =>
  Object.values(CHART_COLOR_BY_SUPPORT);
